import React, { Component } from "react";
import { View, Image, TextInput, Platform } from "react-native";
import Text from "../Text/MyText";

import {
  MainColor,
  SecondaryColor,
  FontMainColor,
  FontSecondaryColor,
  FontThirdColor,
} from "../../UI/Color";
import {
  WidthDimen,
  HeightDimen,
  fontDimen,
  GetWidth,
  GetHeight,
} from "../../UI/Dimensions";

const GameSearchBar = (props) => {
  const { onChangeText, placeholder, marginBottom } = props;

  return (
    <View
      style={{
        width: "100%",
        height: HeightDimen(50),
        backgroundColor: "transparent",
        borderRadius: HeightDimen(10),
        flexDirection: "row",
        alignItems: "center",
        padding: HeightDimen(15),
        marginBottom: marginBottom || 0,
        borderWidth: HeightDimen(1),
        borderColor: "white",
      }}
    >
      <TextInput
        placeholder={placeholder}
        onChangeText={onChangeText}
        placeholderTextColor={"#C7C7CD"}
        style={{
          flex: 1,
          fontSize: fontDimen(15),
          color: "#C7C7CD",
          height: HeightDimen(50),
        }}
      />
      <Image
        source={require("../../Resources/Images/icon_search.png")}
        style={{
          width: "auto",
          height: HeightDimen(15),
          aspectRatio: 1 / 1,
          resizeMode: "contain",
        }}
      />
    </View>
  );
};

export { GameSearchBar };
